<template>
  <el-dialog
    :title="$lang('短信发送')"
    :visible.sync="visible"
    width="30%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      class="custom-form"
      :model="formData"
      :rules="formRules"
      @submit.native.prevent
    >
      <el-form-item label="回电号码" prop="number">
        <el-input
          v-model="formData.number"
          :maxlength="20"
          :placeholder="$lang('请输入')"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="" prop="templateTypeId">
        <el-radio-group
          v-model="formData.templateId"
          @change="handleChange"
        >
          <el-radio
            v-for="item in templateList"
            :key="item.id"
            :label="item.id"
          >
            {{ item.templateName }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="content">
        <div>
          <el-input
            v-model="formData.content"
            disabled
            type="textarea"
            :maxlength="500"
            show-word-limit
          />
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit"
        >提交</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { DICT } from '@/common/utils/dict';
import { RULES } from '@/common/utils/validators';
import { RESPONSE_CODE } from '@public/http/config';
import { workOrderSms } from './pool';

export default {
  name: 'SendSmsDialog',
  props: {
    type: {
      // 短信类型
      type: [Number, String],
      default: null
    },
    callBackPhone: {
      // 回电号码
      type: [Number, String],
      default: null
    },
    waybillNo: {
      // 运单号
      type: [Number, String],
      default: null
    },
    firstProblemTypeCode: {
      // 一级问题类型
      type: [Number, String],
      default: null
    },
    showData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      COM_HTTP: workOrderSms,
      visible: false,
      submitLoading: false,
      formData: {
        templateTypeId: 1,
        number: '',
        content: '',
        templateId: ''
      },
      templateList: [], // 展示模板列表
      activeTplId: '', // 选中模板
      DICT,
      formRules: {
        number: [RULES.required, RULES.phoneNumber],
        content: [
          { validator: this.validatePass, trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchSmsTemplate(this.formData.templateTypeId);
        this.formData.number = this.callBackPhone || '';
        setTimeout(() => {
          this.$refs.formData.validateField('number');
        });
      }
    }
  },
  methods: {
    /**
     * 重置弹窗内容
     */
    reset() {
      this.formData.templateTypeId = 1;
      this.activeTplId = '';
      this.formData.content = '';
      this.$refs.formData.clearValidate();
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.visible = false;
      this.$nextTick(() => {
        this.reset();
      });
    },
    /**
     * 切换模板
     */
    handleChange(value) {
      this.formData.content =
        this.templateList.find((item) => item.id === value)
          ?.templateContent || '';
      this.$refs.formData.clearValidate('content');
    },
    /**
     * 获取短信模板列表
     */
    async fetchSmsTemplate(templateTypeId) {
      try {
        const { callBackPhone, waybillNo } = this;
        const { code, data = [] } = await this.COM_HTTP.reqList({
          templateTypeId,
          smsTypeId: 1,
          callBackPhone,
          waybillNo
        });
        if (code === RESPONSE_CODE.SUCCESS) {
          this.templateList = data;
          this.formData.templateId = data[0]?.id || '';
          this.handleChange(this.formData.templateId, true);
        } else {
          this.templateList = [];
        }
      } catch (e) {
        this.templateList = [];
      }
    },
    /**
     * 选中模板
     */
    selectTemplate(tpl) {
      if (this.activeTplId !== tpl.id) {
        this.activeTplId = tpl.id;
        this.formData.content = tpl.templateContent;
      } else {
        this.activeTplId = '';
        this.formData.content = '';
      }
      this.$refs.formData.validateField('content');
    },
    /**
     * 模板内容校验
     */
    validatePass(rule, value = '', callback) {
      if (value === '') {
        const msg =
          this.formData.templateTypeId === 1 ? '请选择模板' : '请输入';
        callback(new Error(msg));
      } else {
        callback();
      }
    },
    /**
     * 发送短信
     */
    async handleSubmit() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;
            const { callBackPhone, waybillNo } = this;
            const params = {
              ...this.formData,
              smsTypeId: 1,
              waybillNo,
              callBackPhone,
              workOrderNo: this.showData?.workOrderNo || ''
            }
            const { code, msg } = await this.COM_HTTP.sendSms(params);
            if (code === RESPONSE_CODE.SUCCESS) {
              this.$message.success(this.$lang(msg));
              this.handleClose();
            } else {
              this.$message.error(this.$lang(msg));
            }
            this.submitLoading = false;
          } catch (e) {
            this.submitLoading = false;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-form.el-form {
  ::v-deep {
    .el-form-item {
      display: flex;
      flex-direction: column;
      .el-form-item__label {
        text-align: left;
      }
      .el-form-item__content {
        .el-input {
          width: 200px;
        }
      }
    }
  }
}
.tpl-label-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  list-style-type: none;
  padding: 0;
  .tpl-label-item {
    position: relative;
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    margin: 0 8px 8px 0;
    cursor: pointer;
    font-size: 12px;
    @include text-color("routine");
    &.active {
      @include base-color("clr");
      .el-icon-success {
        visibility: visible;
      }
    }
    .el-icon-success {
      visibility: hidden;
      position: absolute;
      top: 0;
      bottom: 0;
      transform: translate(10%, -40%);
      width: 12px;
      height: 12px;
    }
  }
}
</style>
